(() => {
  if (window.guardCollectionSalesLoaded) return;
  window.guardCollectionSalesLoaded = true;
  const selector = '[data-guard-sales-count]';
  const cache = new Map(), pending = new Set(), nextRead = new Map(), requests = new Set();
  const serverNodes = new WeakSet();
  const number = new Intl.NumberFormat(document.documentElement.lang || 'en');
  let scheduled, generation = 0;
  function render() {
    document.querySelectorAll(selector).forEach((badge) => {
      const id = badge.dataset.productId;
      if (!serverNodes.has(badge)) {
        serverNodes.add(badge);
        const count = Number(badge.dataset.serverSalesCount), ttl = Number(badge.dataset.serverSalesTtl);
        if (!cache.has(id) && Number.isSafeInteger(count) && count > 0 && Number.isSafeInteger(ttl) && ttl > 0 && ttl <= 172800) {
          cache.set(id, {count, expiresAt: Date.now() + ttl * 1000});
        }
      }
      const entry = cache.get(id), count = entry && entry.expiresAt > Date.now() ? entry.count : 0;
      const label = badge.querySelector('[data-sales-label]');
      if (/^[1-9]\d{0,19}$/.test(id) && Number.isSafeInteger(count) && count > 0 && label) {
        const text = badge.dataset.label.replace('__COUNT__', number.format(count));
        if (label.textContent !== text) label.textContent = text;
        badge.hidden = false;
      } else badge.hidden = true;
    });
  }
  function paint() {
    render();
    const unknown = new Set();
    document.querySelectorAll(selector).forEach((badge) => {
      const id = badge.dataset.productId;
      if (/^[1-9]\d{0,19}$/.test(id) && !pending.has(id) && Date.now() >= (nextRead.get(id) || 0)) unknown.add(id);
    });
    const ids = [...unknown];
    for (let i = 0; i < ids.length; i += 50) load(ids.slice(i, i + 50));
  }
  async function load(ids) {
    const current = generation, controller = new AbortController();
    requests.add(controller);
    ids.forEach((id) => pending.add(id));
    const timer = setTimeout(() => controller.abort(), 6000);
    try {
      const response = await fetch('https://shopify-download-guard.airjolt2019.workers.dev/api/storefront-sales-counts?basis=shopify-net-units-v2&ids=' + ids.join(','), {
        credentials: 'omit', cache: 'no-store', signal: controller.signal,
      });
      if (!response.ok) throw Error('Counts unavailable');
      const result = await response.json(), age = Date.now() - Date.parse(result.checkedAt);
      if (current !== generation) return;
      if (!result.counts || typeof result.counts !== 'object' || !Number.isFinite(age) || age < 0 || age >= 48 * 3600000) throw Error('Invalid count response');
      ids.forEach((id) => {
        const count = result.counts[id];
        cache.set(id, {count: Number.isSafeInteger(count) && count > 0 ? count : 0, expiresAt: Date.now() + 48 * 3600000 - age});
        nextRead.set(id, Date.now() + 60000);
      });
    } catch {
      if (current === generation) ids.forEach((id) => { nextRead.set(id, Date.now() + 60000); });
    } finally {
      clearTimeout(timer);
      requests.delete(controller);
      if (current === generation) {
        ids.forEach((id) => pending.delete(id));
        render();
      }
    }
  }
  function resetRequests() {
    generation += 1;
    clearTimeout(scheduled);
    requests.forEach((controller) => controller.abort());
    requests.clear();
    pending.clear();
    nextRead.clear();
  }
  const refreshVisible = () => { if (document.visibilityState !== 'hidden') paint(); };
  window.addEventListener('pagehide', resetRequests);
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) resetRequests();
    refreshVisible();
  });
  window.addEventListener('focus', refreshVisible);
  document.addEventListener('visibilitychange', refreshVisible);
  document.addEventListener('shopify:section:load', refreshVisible);
  new MutationObserver((records) => {
    if (!records.some((r) => [...r.addedNodes].some((n) => n.nodeType === 1 && (n.matches?.(selector) || n.querySelector?.(selector))))) return;
    clearTimeout(scheduled); scheduled = setTimeout(paint, 100);
  }).observe(document.body, {childList: true, subtree: true});
  setInterval(refreshVisible, 60000);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paint, {once: true});
  else paint();
})();

